// Client V2 common imports
const { COLLECTION_FOLLOWING_CHANGE } = require('client-v2/common/models/collection/actions')
// Container imports
const FeaturedCollectionsRecord = require('./record')

function featuredCollectionsReducer(state = new FeaturedCollectionsRecord(), action) {
  switch (action.type) {
    case COLLECTION_FOLLOWING_CHANGE:
      return state.itemsReducer(action)
    default:
      return state
  }
}

module.exports = featuredCollectionsReducer
